const sessionParams = new Set(['v', 'redirect', 'referralCode', 'checkout', 'switch', 'trial', 'role']);

export function pullSessionFromUrl(url: URL): void {
  const params = url.searchParams;
  let hasAny = false;
  for (const [key, value] of params.entries()) {
    if (!sessionParams.has(key)) continue;
    hasAny = true;
    sessionStorage.setItem(key, value);
  }
  if (!hasAny) return;

  // Strip only the session params; runs inside router.beforeEach so use
  // history.replaceState (location.replace would trigger another navigation).
  for (const key of sessionParams) params.delete(key);
  const query = params.toString();
  const cleaned = url.pathname + (query ? `?${query}` : '') + url.hash;
  history.replaceState(history.state, '', cleaned);
}
